import React, { useEffect, useState } from 'react'
import BigModal from '../../../../../components/Modals/BigModal'
import { Alert, LinearProgress, Stack, Typography } from '@mui/material'
import API from '../../../../../services/API'
import { LoadingSmall } from '../../../../loading/loadingPage'
import CustomDataGrid from '../../../../../components/DataGrid/CustomDataGrid'
import moment from 'moment'
import SingleDrivingLicenceCheck from './SingleDrivingLicenceCheck'

const ShowAllDrivingLicenceChecks = ({ open, onClose, employeeID }) => {
  const [loading, setLoading] = useState(true)
  const [fetchError, setFetchError] = useState(false)
  const [licenceChecks, setLicenceChecks] = useState([])
  const [selectedCheck, setSelectedCheck] = useState(null)

  useEffect(() => {
    if (open) {
      API.get('/employees/driving-licence-checks/' + employeeID)
        .then((res) => {
          if (res.status === 200) {
            setLicenceChecks(
              res.data.sort((a, b) => moment(b.date) - moment(a.date))
            )
          } else {
            setFetchError(true)
          }
        })
        .catch(() => setFetchError(true))
        .finally(() => setLoading(false))
    }
  }, [open])

  return (
    <BigModal open={open} onClose={onClose}>
      {loading ? (
        <LinearProgress />
      ) : fetchError ? (
        <Alert severity="error">
          Unable to load Driving Licence Checks. Please try again later.
        </Alert>
      ) : (
        <Stack>
          <Typography variant="title2">Driving Licence Checks</Typography>
          <CustomDataGrid
            rows={licenceChecks}
            columns={[
              {
                field: 'date',
                headerName: 'Date',
                minWidth: 150,
                flex: 1,
                renderCell: ({ value }) => moment(value).format('Do MMM YYYY'),
              },
              {
                field: 'validFrom',
                headerName: 'Valid From',
                minWidth: 150,
                flex: 0.5,
                renderCell: ({ value }) => moment(value).format('Do MMM YYYY'),
              },
              {
                field: 'validTo',
                headerName: 'Valid To',
                minWidth: 150,
                flex: 0.5,
                renderCell: ({ value }) => moment(value).format('Do MMM YYYY'),
              },
            ]}
            getRowId={(row) => row._id}
            disableRowSelectionOnClick
            onRowClick={({ row }) => setSelectedCheck(row._id)}
            slots={{
              toolbar: () => null,
              footer: () => null,
            }}
          />
        </Stack>
      )}
      <SingleDrivingLicenceCheck
        checkID={selectedCheck}
        onClose={() => setSelectedCheck(null)}
      />
    </BigModal>
  )
}

export default ShowAllDrivingLicenceChecks
